import { render, staticRenderFns } from "./CareBlnftSrvRcrd.vue?vue&type=template&id=17ff67c2&"
import script from "./CareBlnftSrvRcrd.vue?vue&type=script&lang=js&"
export * from "./CareBlnftSrvRcrd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports